module.exports = __webpack_public_path__ + "static/img/Postal service picture.d4b3c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/Postal service picture.png
// module id = J9i1
// module chunks = 44